import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/packages/tokers-web/src/app/_components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/packages/tokers-web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"workSans\"}");
